export class EntityEmailFilters {
  name: string;
  entityType: string;
  email: string;
  sharedBy: string;
}
